import { Paper } from "@mui/material";
import Card from "components/Dashboard/Card";
import { formatMoney, formatDate } from "./Utils";

export default function LoanLenderInfo(props) {
  const latestLoanInfo = props.estatedProperty.latestLoanInfo;
  const data = {
    "Lender Name": latestLoanInfo
      ? latestLoanInfo.lender_legal_name
      : undefined,
    "Lender Type": latestLoanInfo ? latestLoanInfo.lender_type : undefined,
    "Loan Type": latestLoanInfo ? latestLoanInfo.loan_type : undefined,
    "Loan Amount": formatMoney(
      latestLoanInfo ? latestLoanInfo.loan_amount : undefined
    ),
    "Purchase Price": formatMoney(
      latestLoanInfo ? latestLoanInfo.sale_price : undefined
    ),
    "Loan Date": formatDate(
      latestLoanInfo ? latestLoanInfo.original_contract_date : undefined
    ),
  };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Card label="Loan/Lender Info" activeKey="loan_lender_info" row={data} />
    </Paper>
  );
}
